import React from "react";
import PageLayout from "../components/PageLayout";

export default function Disclaimer() {
    return (
        <PageLayout
            title="Disclaimer"
            subtitle="Learn more about the disclaimer"
            pageTitle="Disclaimer"
            showSearch={false}
            showGradient={true}
        >
            <div className="flex flex-col gap-6 mt-8 text-secondary/80 text-14">
                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-primary mb-4">Website Purpose</h3>
                    <p className="leading-relaxed">
                        Disclaimer: Please note, this website is not an online pharmacy, drugstore and related online pharma shop. It does not sell, supply or advertise any prescription and OTC drugs, medications, other goods and services. All reviews, links, lists, databases, texts, videos, images, and other content on the website are provided free and only for informational and educational purposes.
                    </p>
                </div>

                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-primary mb-4">Content Sources</h3>
                    <p className="leading-relaxed">
                        Medical content on this website, including drug names, indications, contraindication, side effects, categories, classifications, forms, doses, prices, other health and pharmaceutical information are taken only from trusted and authoritative professional sources (see "References"), reviewed and prepared by our licensed experts, content inspectors and editors.
                    </p>
                </div>

                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-primary mb-4">Medical Advice</h3>
                    <p className="leading-relaxed">
                        You should always consult your doctor or other healthcare professional before using any medication. This website, our staff and support do not provide own medical instructions and advices.
                    </p>
                </div>

                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-primary mb-4">Trademarks</h3>
                    <p className="leading-relaxed">
                        All brands and trade names appearing on the website are registered trademarks and intellectual property of their respective companies.
                    </p>
                </div>

                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-primary mb-4">Legal Responsibility</h3>
                    <p className="leading-relaxed">
                        Remember that buying drugs and medicines online is a responsibility only of customers, sellers and suppliers regarding existing legislation in their jurisdictions.
                    </p>
                </div>
            </div>
        </PageLayout>
    );
}